import React, { useEffect, useReducer, useState } from 'react';

import { useAuth } from '../../Context';
import { Content } from 'antd/es/layout/layout';
import { Avatar, Button, Card, Col, Empty, Form, Input, message, Modal, Popover, Row,  Space, Spin, Switch, Table,  Typography } from 'antd';
import { EditOutlined, PlusOutlined, DeleteOutlined, InfoOutlined, ProjectOutlined } from '@ant-design/icons';
import englan from '../../../english.json';
import germanlan from '../../../german.json';
import arabiclan from '../../../arabic.json';
import frenchlan from '../../../french.json';
import hindilan from '../../../hindi.json';
import malayalamlan from '../../../malayalam.json';
import axios from 'axios';
import wellAlgorithmInfoReducer from './reducer';
import { DATA_GENERATION_LIST, DATA_GENERATION_LIST_ERROR, DATA_GENERATION_LIST_SUCCESS, EDIT_FILTER_CONFIG, EDIT_FILTER_CONFIG_ERROR, EDIT_FILTER_CONFIG_SUCCESS, WELL_ALGORITHM_INFO_CREATE, WELL_ALGORITHM_INFO_CREATE_ERROR, WELL_ALGORITHM_INFO_CREATE_SUCCESS, WELL_ALGORITHM_INFO_DELETE, WELL_ALGORITHM_INFO_DELETE_ERROR, WELL_ALGORITHM_INFO_DELETE_SUCCESS, WELL_ALGORITHM_INFO_UPDATE_DATA } from './constants';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';

const { Title } = Typography;

export default function DataGeneration() {
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	const pipelineId = localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) ? localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) : null;
	const initalState = {wellalgorithmUpdateData : {}, loading: false, error: false, datageneration : []};
	const [data, dispatch] = useReducer(wellAlgorithmInfoReducer, initalState);
	const [isEditModalOpen, setIsEditModalOpen] = useState(false);
	const [isAddModalOpen, setIsAddModalOpen] = useState(false);
	const [existingConfig, setexistingConfigs] = useState([]);
	// const {wellalgorithmdata} = useAuth();
	useAuth();
	// const [updateId, setUpdateId]= useState();
	const [showDeleteModal, setShowDeleteModal] = useState();
	const [deleteId, setDeleteId] = useState();
	// const [overrideBtn, setOverrideBtn] = useState(false);
	const permission = localStorage.getItem(`${dashboardtype.toUpperCase()}_PERMISSION`);

	const [stateconfigs, setStateConfigs] = useState([{name : '', value : '' , default : '' , override : false}]);
	// const [form] = Form.useForm();	
	const navigate = useNavigate();
	const featuresModule = JSON.parse(localStorage.getItem(`${dashboardtype.toUpperCase()}_FEATURES_MODULE_DASHBOARD`));

	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;
	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;	
	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	useEffect(() => {
		if(featuresModule.datagenerationtypeEnabled == false) {
			navigate('/dashboard');
		}
		window.scrollTo(0, 0);
		localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' ,411);
		loadDataGeneration();
	}, []);

	


	const loadDataGeneration = ()=>{    
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/datagenerationtype/?pipelineId=${pipelineId}&$sort[id]=-1`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				Authorization:`Bearer ${authtoken}`				
			},
		};
		dispatch({type : DATA_GENERATION_LIST});
		axios.request(config)
			.then((response) => {
				if(response.status == 200 || response.status == 201){	
                                        
					dispatch({ type : DATA_GENERATION_LIST_SUCCESS, payload: response.data.data });
				} else {
					dispatch({ type : DATA_GENERATION_LIST_ERROR});			
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : DATA_GENERATION_LIST_ERROR });
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				} else {
					// Modal.warning({ title: langdata && langdata.Unabletoupdatealgorithm ? langdata.Unabletoupdatealgorithm : 'Unable to update algorithm.' });											
				}
			});
	};

	const columns = [
		{
			title: langdata && langdata.Name ? langdata.Name : 'Name',
			dataIndex: 'name',
			key: 'name',
			
		},
	];
	
	permission==='superadmin' || permission === 'admin' ? 
		columns.push({
			title: langdata && langdata.Actions ? langdata.Actions : 'Actions',
			key: 'action',
			render: (_,record) => (
				<Space size="middle">
					<a title={langdata && langdata.Edit ? langdata.Edit : 'Edit'} onClick={() => {showModal(record);}} ><EditOutlined/></a>
					<a title={langdata && langdata.Delete ? langdata.Delete : 'Delete'} onClick={() => {openUserModal(record);}} ><DeleteOutlined /></a>
				</Space>
			)
		}) : null;

	
	const showModal = (value) => {
		setIsEditModalOpen(true);
		dispatch({ type : WELL_ALGORITHM_INFO_UPDATE_DATA , payload : value});
		setexistingConfigs(Object.entries(value?.configs));
	};

	const handleOk = () => {
		setIsEditModalOpen(false);
		setIsAddModalOpen(false);
		setShowDeleteModal(false);
		createFormik.resetForm();
		
	};
	const handleCancel = () => {
	
		setIsEditModalOpen(false);
		setIsAddModalOpen(false);
		setShowDeleteModal(false);
		setStateConfigs([{name : '', value : '' , default : '' , override : false}]);
		createFormik.resetForm();

	};	

	// const updateFormik = useFormik({
	// 	enableReinitialize: true,
	// 	initialValues : {
	// 		name : data.wellalgorithmUpdateData.name,
	// 	},
	// 	onSubmit: (values) => {
	// 		const {name } = values;			
	// 		if(name == null){
	// 			Modal.warning({title : langdata && langdata.Pleasefillallthefields ? langdata.Pleasefillallthefields : 'Please fill all the fields'});
	// 			return false;
	// 		}
			
	// 		dispatch({ type : WELL_ALGORITHM_INFO_UPDATE });
	// 		let data = JSON.stringify({
	// 			'name': name,
	// 		});

	// 		let config = {
	// 			method: 'patch',
	// 			maxBodyLength: Infinity,
	// 			url: `${api}/wellalgorithm/${updateId}`,
	// 			timeout: timeout,
	// 			headers: { 
	// 				'Content-Type': 'application/json', 
	// 				Authorization:`Bearer ${authtoken}`				
	// 			},
	// 			data : data
	// 		};

	// 		axios.request(config)
	// 			.then((response) => {
	// 				if(response.status == 200 || response.status == 201){
	// 					getWellAlgorithm(authtoken);
	// 					Modal.success({ title: langdata && langdata.Algorithmupdatedsuccessfully ? langdata.Algorithmupdatedsuccessfully : 'Algorithm updated successfully.' });					
	// 					dispatch({ type : WELL_ALGORITHM_INFO_UPDATE_SUCCESS });
		
	// 				} else {
	// 					dispatch({ type : WELL_ALGORITHM_INFO_UPDATE_ERROR});
	// 					Modal.warning({ title: langdata && langdata.Unabletoupdatealgorithm ? langdata.Unabletoupdatealgorithm : 'Unable to update algorithm' });					
	// 				}
	// 			})
	// 			.catch((error) => {
	// 				console.log(error);
	// 				dispatch({ type : WELL_ALGORITHM_INFO_UPDATE_ERROR });
	// 				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
	// 					message.config({
	// 						duration : 5,
	// 						maxCount : 1,
	// 					});
	// 					message.open({
	// 						type: 'error',
	// 						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
	// 					});
	// 				} else {
	// 					Modal.warning({ title: langdata && langdata.Unabletoupdatealgorithm ? langdata.Unabletoupdatealgorithm : 'Unable to update algorithm.' });											
	// 				}
	// 			});
			
	// 		setIsEditModalOpen(false);
	// 	}
	// });	
	const createFormik = useFormik({
		// enableReinitialize: true,
		initialValues : {
			name : null,
			
		},
		onSubmit: (values) => {
			if( name == null){
				Modal.warning({title : langdata && langdata.Pleasefillallthefields ? langdata.Pleasefillallthefields : 'Please fill all the fields'});
				return false;
			}
			const payload = {
				name: values.name,
				configs: {
					...buildConfigsFromState(stateconfigs),
				},
				pipelineId : parseInt(pipelineId)
			};
			
		
			
			dispatch({ type : WELL_ALGORITHM_INFO_CREATE });
			// let data = JSON.stringify({
			// 	'name' : name,
			// 	'pipelineId':parseInt(pipelineId)
				
			// });

			let config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: `${api}/datagenerationtype`,
				timeout: timeout,
				headers: { 
					'Content-Type': 'application/json', 
					Authorization:`Bearer ${authtoken}`				},
				data : {
					name : payload.name,
					configs : payload.configs,
					pipelineId : payload.pipelineId
				} 
			};

			axios.request(config)
				.then((response) => {
					if(response.status == 200 || response.status == 201){
						loadDataGeneration();	
						Modal.success({ title: langdata && langdata.Algorithmsavedsuccessfully ? langdata.Algorithmsavedsuccessfully : 'Algorithm saved successfully.' });					
						dispatch({ type : WELL_ALGORITHM_INFO_CREATE_SUCCESS });
					} else {
						dispatch({ type : WELL_ALGORITHM_INFO_CREATE_ERROR });
						Modal.warning({ title: langdata && langdata.Unabletosavealgorithm ? langdata.Unabletosavealgorithm : 'Unable to save algorithm' });					
					}
				})
				.catch((error) => {
					console.log(error);
					dispatch({ type : WELL_ALGORITHM_INFO_CREATE_ERROR });
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					} else {
						Modal.warning({ title: langdata && langdata.Unabletosavealgorithm ? langdata.Unabletosavealgorithm : 'Unable to save algorithm' });					
					}
				});
			createFormik.resetForm();
			setIsAddModalOpen(false);
			setStateConfigs([{name : '' , value : '', default : '', override : false}]);

		}
	});	
		
	const openUserModal = (value) => {
		setShowDeleteModal(true);
		setDeleteId(value.id);
	};

	const handleDelete = () => {
		dispatch({ type : WELL_ALGORITHM_INFO_DELETE });
		let config = {
			method: 'delete',
			maxBodyLength: Infinity,
			url: `${api}/datagenerationtype/${deleteId}`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				Authorization:`Bearer ${authtoken}`				},
			data : data
		};

		axios.request(config)
			.then((response) => {
				if(response.status == 200 || response.status == 201){
					loadDataGeneration();					
					Modal.success({ title: langdata && langdata.Algorithmsuccessfullydeleted ? langdata.Algorithmsuccessfullydeleted : 'Algorithm successfully deleted.' });					
					dispatch({ type : WELL_ALGORITHM_INFO_DELETE_SUCCESS });
				} else {
					Modal.warning({ title: langdata && langdata.Unabletodeletealgorithm ? langdata.Unabletodeletealgorithm : 'Unable to delete algorithm.' });					
					dispatch ({ type : WELL_ALGORITHM_INFO_DELETE_ERROR });
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch ({ type : WELL_ALGORITHM_INFO_DELETE_ERROR });
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				} else {
					Modal.warning({ title: langdata && langdata.Unabletodeletealgorithm ? langdata.Unabletodeletealgorithm : 'Unable to delete algorithm.' });
				}
			});
		setShowDeleteModal(false);
	};

	const infoContent = (
		<Card size="small" bordered="false" type="inner" style={{ width: 300 }}> 
			<p style={{textAlign:'justify'}}> {langdata && langdata.DataGenerationInfoContent ? langdata.DataGenerationInfoContent : 'Module is responsible for generating structured inputs from raw fiber-optic sensing data by extracting, transforming, and reshaping relevant features'} </p>
		</Card>
	);

	const buildConfigsFromValues = (values) => {
		const configsMap = {};

		Object.keys(values).forEach((k) => {
			if (k === 'name') return;

			if (k.endsWith('value')) {
				const baseKey = k.replace('value', '');
				configsMap[baseKey] = configsMap[baseKey] || {};
				configsMap[baseKey].value = !isNaN(values[k]) ? parseFloat(values[k]) : values[k];
			}

			if (k.endsWith('default')) {
				const baseKey = k.replace('default', '');
				configsMap[baseKey] = configsMap[baseKey] || {};
				configsMap[baseKey].default = !isNaN(values[k]) ? parseFloat(values[k]) : values[k];
			}

			if (k.endsWith('override')) {
				const baseKey = k.replace('override', '');
				configsMap[baseKey] = configsMap[baseKey] || {};
				configsMap[baseKey].override = values[k];
			}
		});

		// Return object (not array)
		return configsMap;
	};

	const buildConfigsFromState = (stateconfigs) => {
		return stateconfigs.reduce((acc, item) => {
			if (item.name && item.value !== '') {
				acc[item.name] = {
					value: !isNaN(item.value) ? parseFloat(item.value) : item.value,
					default: !isNaN(item.default) ? parseFloat(item.default) : item.default,
					override: Boolean(item.override),
				};
			}
			return acc;
		}, {});
	};

	const editFilterConfig = useFormik({
		enableReinitialize: true,
		// initialValues : {
		// 	name : data.wellalgorithmUpdateData.name,
		// },
		initialValues: {
			name: data?.wellalgorithmUpdateData?.name,

			...(existingConfig
				? existingConfig.reduce(
					(acc, [key, inner]) => {
						acc[`${key}value`] =inner.value;
						acc[`${key}default`] = inner.default;
						acc[`${key}override`] = inner.override;
						return acc;
					},
					{}
				)
				: {}),

		},
		onSubmit: (values) => {

			const payload = {
				name: values.name,
				configs: {
					...buildConfigsFromValues(values),
					...buildConfigsFromState(stateconfigs),
				},
				
			};

			dispatch({type:EDIT_FILTER_CONFIG});
			let config = {
				method: 'patch',
				maxBodyLength: Infinity,
				url: `${api}/datagenerationtype/${data?.wellalgorithmUpdateData?.id}`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${authtoken}`
				},
				data:{
					name : payload.name,
					configs : payload.configs
				}
			};
		
			axios
				.request(config)	
				.then((response) => {
							
		
					if (response.status === 200 || response.status === 201) {
		
			
						dispatch( { type: EDIT_FILTER_CONFIG_SUCCESS, payload: response.data.data });
		
						Modal.success({ title: `${langdata && langdata.EditDataGenerationTypeSuccessfull ? langdata.EditDataGenerationTypeSuccessfull :'Edit Data Generation Type Successfull'}` });
						setIsEditModalOpen(false);
						loadDataGeneration();
						setStateConfigs([{name : '', value : '' , default : '' , override : false}]);
						// loadFilterConfiguration();
						// form.resetFields();
						// addModelClassification.resetForm();
						// setOpenAddDrawer(false);
		
							
					}
				})
				.catch((error) => {
					console.log(error);
							
					dispatch({ type: EDIT_FILTER_CONFIG_ERROR
					});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
						});
					}
				});
		
		}
	});



	const handleOverride = (value, key)=>{
		editFilterConfig.setFieldValue(`${key}override`, value);
	};

	const handleFilterConfig = () => {
		// setSuppressionValues([...suppressionValues, { Start: '', End: '' }]);
		setStateConfigs([...stateconfigs, {name : '' , value : '', default : '', override : false}]);
	};

	const handleChangeConfigs = (index, key, e)=>{

		const newConfig = [...stateconfigs];
		if(key == 'override'){
			newConfig[index][key] = e;
		}else{
			newConfig[index][key] = e.target.value;
		}
		setStateConfigs(newConfig);
	};


	const handleDeleteConfig = (index) => {
		setStateConfigs(stateconfigs.filter((_, i) => i !== index));
	};

	const handleDeleteexistingConfig = (index) => {
		setexistingConfigs(existingConfig.filter((_, i) => i !== index));
	};

	

	
	return (
		<Content>
			<Row style={{
				margin: '10px',
				paddingLeft: '10px',
				paddingRight: '10px',
				background: '#FFFFFF',
				alignItems:'center',
			}}
			>
				<Col span={8}>
					<Row>
						<Space>
							<ProjectOutlined style={{fontSize:'30px'}} />
						</Space>
						<Space>&nbsp;&nbsp;</Space>
						<Title level={4} style={{ paddingTop:'10px'}}>{langdata && langdata.DataGeneration ? langdata.DataGeneration : 'Data Generation'}</Title>
					</Row>
				</Col>
				<Col span={16}>
					<Row justify="end">
						<Col>
							{/* <Text style={{ display: 'flow', paddingTop: '4px', textAlign: 'end',  marginRight: '4px' }}>User Type:</Text> */}
							{ permission==='superadmin' || permission === 'admin' ? 
								<Space>
									<Space>&nbsp;</Space>
									<Button style={{margin:'5px'}} type="primary" onClick={() => {setIsAddModalOpen(true);}}><PlusOutlined/>{langdata && langdata.AddNew ? langdata.AddNew : 'Add New'}</Button>
								</Space>
								: null }
							<Space>&nbsp;&nbsp;&nbsp;</Space>
							
							<Popover title={langdata && langdata.FilterAlgorithm ? langdata.FilterAlgorithm : 'Filter Algorithm'}  content={infoContent} trigger="click">
								<Avatar size="small"><InfoOutlined /></Avatar>
							</Popover>
						</Col>
					</Row>
				</Col>
			</Row>
			<Row span={24} style={{
				margin: '10px',
				paddingLeft: '10px',
				paddingRight: '10px',
				background: '#FFFFFF',
				alignItems:'center'
			}} >
				<Col span={24}>
					{ data?.datageneration && data.datageneration.length > 0 ? (
						<Table
							scroll={{
								x: 900,
							}}
							columns = { columns } 
							dataSource = { data?.datageneration } 
						/>
					)
						:
						(
							<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
						)}
				</Col>
			</Row>
			<Modal
				title={langdata && langdata.EditDataGenerationType ? langdata.EditDataGenerationType : 'Edit Data Generation Type'}
				centered
				open={isEditModalOpen}
				onOk={handleOk}
				onCancel={handleCancel}
				maskClosable={false}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={handleCancel}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE'}</Button>
						<Button type="primary"  onClick={editFilterConfig.handleSubmit}>{langdata && langdata.UPDATE ? langdata.UPDATE : 'UPDATE'}</Button>
					</Space>
				]}
				width={900}
			>
				<Form layout="vertical" >
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata && langdata.DataGenerationName ? langdata.DataGenerationName : 'Data Generation Name'} rules={[{ required: false, message: langdata && langdata.Pleasefillthename ? langdata.Pleasefillthename : 'Please fill the name' }]} required>
								<Input 
									name="name" 
									onChange={editFilterConfig.handleChange} 
									disabled
									value={editFilterConfig.values.name}
								/>
							</Form.Item>
						</Col>
						
					</Row>
					<Row gutter={24}>
						<Col span={12} style={{marginBottom : '15px'}}>
							<Typography strong style={{fontSize:'16px', color:'grey'}}><b>&#9658; {langdata && langdata.Configuration ? langdata.Configuration:'Configuration'}</b></Typography>
						</Col>
					</Row>

					{
						existingConfig.length <= 0 ? (
							<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
						) : null
					}
					
					{
						existingConfig.map(([key], index) => (
							
								
							<Row gutter={24} key={key}>
								<Col span={7} >
									<Form.Item
										label={
											<Typography style={{minHeight:index == 0 ? '' : 'none',marginTop : '10px'}}>
												{index === 0 ? langdata?.Name || 'Name' : ''}
											</Typography>
										}
									>
										<Input
												
											disabled
											value={key}
										/>
									</Form.Item>
								</Col>
								<Col span={6} >
									<Form.Item
										label={
											<Typography style={{minHeight:index == 0 ? '' : '0px', marginTop : '10px'}}>
												{index === 0 ? langdata?.Value || 'Value' : ''}
											</Typography>
										}
									>
										<Input
											name={`${key}value`}
											onChange={editFilterConfig.handleChange}
											disabled={editFilterConfig.values[`${key}override`] ? false : true}
												
											value={editFilterConfig.values[`${key}value`]}
										/>
									</Form.Item>
								</Col>
								<Col span={6} >
									<Form.Item
										label={
											<Typography style={{minHeight:index == 0 ? '' : '0px', marginTop : '10px'}}>
												{index === 0
													? langdata?.DefaultValue || 'DefaultValue' : ''}
											</Typography>
										}
									>
										<Input
											name={`${key}default`}
											disabled
											onChange={editFilterConfig.handleChange}
												
											value={editFilterConfig.values[`${key}default`]}
										/>
									</Form.Item>
								</Col>
								<Col span={3} style={{justifyContent: 'center', display : 'flex'}}  >
									<Form.Item
										label={
											<Typography style={{minHeight:index == 0 ? '' : '0px', marginTop : '10px', minWidth : '50px'}} >
												{index === 0 ? langdata?.Override || 'Override' : ''}
											</Typography>
										}
									>
										<Switch
												
											size="small"
											checked={editFilterConfig.values[`${key}override`]}
											onChange={(value) => handleOverride(value, key)}
										/>
									</Form.Item>
								</Col>
								<Col span={2} style={{ marginTop : '35px' , marginLeft : '', textAlign: 'center' }}>
									<Button
										danger
										icon={<DeleteOutlined />}
										onClick={() => handleDeleteexistingConfig(index)}
										disabled={existingConfig.length === 0}
									/>
								</Col>
							</Row>

							
						)
						)
					}

					<Row gutter={24}>
						<Col span={12}>
							<Typography strong style={{fontSize:'16px', color:'grey'}}><b>&#9658; {langdata && langdata.NewConfiguration ? langdata.NewConfiguration:'New Configuration'}</b></Typography>
						</Col>
						<Col span={12} justifyContent="end" style={{display:'flex', justifyContent:'flex-end'}}>
							<Button
								style={{margin:'5px'}} 
								type="primary" 
								icon={<PlusOutlined />}
								onClick={handleFilterConfig}
							/>
						</Col>
					</Row>
					{
						stateconfigs.map((item, stateindex)=>{
							return (
								<Row gutter={24} key={stateindex} >
									<Col span={7} >
										<Form.Item
											label={
												<Typography style={{minHeight:stateindex == 0 ? '' : 'none',marginTop : '10px'}}>
													{stateindex === 0 ? langdata?.Name || 'Name' : ''}
												</Typography>
											}
										>
											<Input
												placeholder={langdata && langdata.Pleasefillthename ? langdata.Pleasefillthename : 'Please fill the name'}
												onChange={e => 	handleChangeConfigs(stateindex, 'name', e)}
												value={item.name}
											/>
										</Form.Item>
									</Col>
									<Col span={6} >
										<Form.Item
											label={
												<Typography style={{minHeight:stateindex == 0 ? '' : '0px', marginTop : '10px'}}>
													{stateindex === 0 ? langdata?.Value || 'Value' : ''}
												</Typography>
											}
										>
											<Input
												onChange={e => handleChangeConfigs(stateindex, 'value', e)}
												value={item.value}
												placeholder={langdata && langdata.Value ? langdata.Value : 'Value'}
											/>
										</Form.Item>
									</Col>
									<Col span={6} >
										<Form.Item
											label={
												<Typography style={{minHeight:stateindex == 0 ? '' : '0px', marginTop : '10px'}}>
													{stateindex === 0
														? langdata?.DefaultValue || 'DefaultValue' : ''}
												</Typography>
											}
										>
											<Input
												onChange={e => handleChangeConfigs(stateindex, 'default', e)}
												value = {item.default}
												placeholder={langdata && langdata.DefaultValue ? langdata.DefaultValue : 'Default Value'}
												// value={editFilterConfig.values[`${item.name}default`]}
											/>
										</Form.Item>
									</Col>
									<Col span={3}  style={{justifyContent: 'center', display : 'flex'}}>
										<Form.Item
											label={
												<Typography style={{minHeight:stateindex == 0 ? '' : '0px', marginTop : '10px', minWidth : '50px'}} >
													{stateindex === 0 ? langdata?.Override || 'Override' : ''}
												</Typography>
											}
										>
											<Switch
												
												size="small"
												checked={item.override}
												onChange = {(e)=> {
													handleChangeConfigs(stateindex, 'override', e);		
												}}
											/>
										</Form.Item>
									</Col>

									<Col span={2} style={{ marginTop : '35px' , marginLeft : '', textAlign: 'center' }}>
										<Button
											danger
											icon={<DeleteOutlined />}
											onClick={() => handleDeleteConfig(stateindex)}
											disabled={stateconfigs.length === 0}
										/>
									</Col>
								</Row>);
						})
					}


					
					
					
				</Form>
			</Modal>


			<Modal
				title={langdata && langdata.AddDataGenerationType ? langdata.AddDataGenerationType : 'Add Data Generation Type'}
				centered
				open={isAddModalOpen}
				onOk={handleOk}
				onCancel={handleCancel}
				maskClosable={false}
				destroyOnClose= {true}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={handleCancel}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE'}</Button>
						<Button type="primary"  onClick={createFormik.handleSubmit}>{langdata && langdata.SAVE ? langdata.SAVE : 'SAVE'}</Button>
					</Space>
				]}
				width={900}
			>
				<Form layout="vertical" >
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata && langdata.DataGenerationName ? langdata.DataGenerationName : 'Data Generation Name'} rules={[{ required: true, message: langdata && langdata.Pleasefillthename ? langdata.Pleasefillthename : 'Please fill the name' }]} required>
								<Input 
									name="name" 
									placeholder={langdata && langdata.Pleasefillthename ? langdata.Pleasefillthename : 'Please fill the name'}
									onChange={createFormik.handleChange} 
								/>
							</Form.Item>
						</Col>
					</Row>

					<Row gutter={24}>
						<Col span={12}>
							<Typography strong style={{fontSize:'16px', color:'grey'}}><b>&#9658; {langdata && langdata.NewConfiguration ? langdata.NewConfiguration:'New Configuration'}</b></Typography>
						</Col>
						<Col span={12} justifyContent="end" style={{display:'flex', justifyContent:'flex-end'}}>
							<Button
								style={{margin:'5px'}} 
								type="primary" 
								icon={<PlusOutlined />}
								onClick={handleFilterConfig}
							/>
						</Col>
					</Row>

					{
						stateconfigs.map((item, stateindex)=>{
							return (
								<Row gutter={24} key={stateindex} >
									<Col span={7} >
										<Form.Item
											label={
												<Typography style={{minHeight:stateindex == 0 ? '' : 'none',marginTop : '10px'}}>
													{stateindex === 0 ? langdata?.Name || 'Name' : ''}
												</Typography>
											}
										>
											<Input
												placeholder={langdata && langdata.Pleasefillthename ? langdata.Pleasefillthename : 'Please fill the name'}
												onChange={e => 	handleChangeConfigs(stateindex, 'name', e)}
												value={item.name}
											/>
										</Form.Item>
									</Col>
									<Col span={6} >
										<Form.Item
											label={
												<Typography style={{minHeight:stateindex == 0 ? '' : '0px', marginTop : '10px'}}>
													{stateindex === 0 ? langdata?.Value || 'Value' : ''}
												</Typography>
											}
										>
											<Input
												onChange={e => handleChangeConfigs(stateindex, 'value', e)}
												placeholder={langdata && langdata.Value ? langdata.Value : 'Value'}
												value={item.value}
											/>
										</Form.Item>
									</Col>
									<Col span={6} >
										<Form.Item
											label={
												<Typography style={{minHeight:stateindex == 0 ? '' : '0px', marginTop : '10px'}}>
													{stateindex === 0
														? langdata?.DefaultValue || 'DefaultValue' : ''}
												</Typography>
											}
										>
											<Input
												onChange={e => handleChangeConfigs(stateindex, 'default', e)}
												value = {item.default}
												placeholder={langdata && langdata.DefaultValue ? langdata.DefaultValue : 'Default Value'}
												// value={editFilterConfig.values[`${item.name}default`]}
											/>
										</Form.Item>
									</Col>
									<Col span={3}  >
										<Form.Item
											label={
												<Typography style={{minHeight:stateindex == 0 ? '' : '0px', marginTop : '10px'}} >
													{stateindex === 0 ? langdata?.Override || 'Override' : ''}
												</Typography>
											}
										>
											<Switch
												
												size="small"
												checked={item.override}
												onChange = {(e)=> {
													handleChangeConfigs(stateindex, 'override', e);		
												}}
											/>
										</Form.Item>
									</Col>
									<Col span={2} style={{ marginTop : '35px' , marginLeft : '', textAlign: 'center' }}>
										<Button
											danger
											icon={<DeleteOutlined />}
											onClick={() => handleDeleteConfig(stateindex)}
											disabled={stateconfigs.length === 0}
										/>
									</Col>
								</Row>);
						})
					}
				</Form>
			</Modal>

			<Modal title={langdata && langdata.Confirmdelete ? langdata.Confirmdelete : 'Confirm delete'} open={showDeleteModal} onOk={handleOk} onCancel={handleCancel}
				footer={[
				// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={handleCancel}>{langdata && langdata.CANCEL ? langdata.CANCEL : 'CANCEL'}</Button>
						<Button key="submit" type="primary" onClick={handleDelete}>{langdata && langdata.DELETE ? langdata.DELETE : 'DELETE'}</Button>
					</Space>
				]}>
				<Row style={{
					marginTop: '10px',
					marginBottom: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={1}>
						<DeleteOutlined  style={{ fontSize: '14px'}}/>
					</Col>
					<Col span={23}>{ langdata && langdata.Areyousureyouwanttodeletethisalgorithm ? langdata.Areyousureyouwanttodeletethisalgorithm :'Are you sure you want to delete this algorithm?'}</Col>
				</Row>
			</Modal>

			<Spin fullscreen spinning={data.loading} />
		</Content>
	);
}